module.exports = ".cursor {\n  cursor: pointer; }\n"